import store from '@/store';

export function generateModuleConfigGetter(module_code) {
  return (key) => store.getters["liffModule/getConfig"](module_code, key);
}
